import * as React from 'react';
import classnames from 'classnames';

import ActionLink from 'components/buttons/action-link/ActionLink';
import Popover from 'components/popover/Popover';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import type { SVGDynamicIconCustomColor } from 'types';

import './influencer-verification-label.scss';

applyTranslations(require('./influencer-verification-label.i18n.json'));

const DETAILS_MAP: {
  [x: string]: {
    name: string,
    color: SVGDynamicIconCustomColor
  }
} = {
  verified: {
    name: 'shield-checkmark-inside-custom-bg-white-fg',
    color: 'primary'
  },
  unverified: {
    name: 'shield-custom-bg',
    color: 'grey'
  }
};

type Props = {
  type: 'all' | 'verified' | 'unverified',
  withMargin?: boolean
};

class InfluencerVerificationLabel extends React.PureComponent<Props> {
  renderIcon() {
    const { type, withMargin } = this.props;

    if (type === 'all') {
      return null;
    }

    const classes = classnames('influencer-verification-label__icon', {
      'influencer-verification-label__icon--with-margin': withMargin
    });

    return (
      <div className={classes}>
        <SVGDynamicIcon
          name={DETAILS_MAP[type].name}
          width={13}
          height={16}
          customColor={DETAILS_MAP[type].color}
        />
      </div>
    );
  }

  render() {
    const { type } = this.props;

    const classes = classnames('influencer-verification-label', {
      [`influencer-verification-label--type-${type}`]: type
    });

    return (
      <Popover
        showQuestionMark={type === 'all'}
        triggerComponent={type !== 'all' && this.renderIcon()}
        classNameTrigger="influencer-verification-label__trigger"
      >
        <div className={classes}>
          {__t(`influencer_verification_label.${type}`)}&nbsp;
          <ActionLink
            openInNewTab
            size="inherit"
            color="secondary"
            decoration="none"
            link="https://help.collabary.com/en/articles/3493347-content-creator-profiles"
          >
            {__t('influencer_verification_label.link')}
          </ActionLink>
        </div>
      </Popover>
    );
  }
}

export default InfluencerVerificationLabel;
